import React from "react";
import LoseWeight from "../Assets/loseweight.jpg";
import Lifestyle from "../Assets/lifestyle.jpg";
import Recipes from "../Assets/recipe.jpg";

const Work = () => {
  const workInfoData = [
    {
      image: LoseWeight,
      title: "You'll lose targeted fat",
      text: "Our program focuses on burning fat in those hard-to-lose areas for a healthier body and more toned body.",
    },
    {
      image: Lifestyle,
      title: "Adopt a healthier diet and lifestyle",
      text: "Transform your health. Get the tools you need to make lasting lifestyle changes that will improve your well-being.",
    },
    {
      image: Recipes,
      title: "Access over 100 fitness recipes",
      text: "Never get bored, our recipe collection offers a variety of options to suit different dietary preferences and fitness needs.",
    },
  ];
  return (
    <div className="work-section-wrapper">
      <div className="work-section-top">
        <p className="primary-subheading">How It Works </p>
        <h1 className="primary-heading-edit">What benefits will you gain from participating in our project?</h1>
        <p className="primary-text">
          Our project offers the perfect combination of fitness and nutrition to help you lose weight and achieve your desired body shape. With our targeted weight loss program, you'll burn fat in those hard-to-lose areas for a leaner, healthier body. Plus, you'll have access to over 100 delicious and healthy recipes that support your fitness goals.
        </p>    
      </div>
      <div className="work-section-bottom">
        {workInfoData.map((data) => (
          <div className="work-section-info" key={data.title}>
            <div className="info-boxes-img-container">
              <img src={data.image} alt="" />
            </div>
            <h2><span className="changeColor">{data.title}</span></h2>
            <p>{data.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Work;
